import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../localization/language';
import { VERIFICATION_TOOL, CUSTOM_SERVICE_URL } from '../../constants';
import * as unlockActions from '../../actions/unlock';
import * as verificationActions from '../../actions/verification';
import * as mobileActions from '../../actions/mobile';
import { getFullMobileNo, getSendOTPErrorMessage, getUnlockErrorMessage } from '../../utils.js';
import MobileOtpInputField from '../security/verification/MobileOtpInputField';

class UnlockVerify extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			code: '',
			gatewayBefore: undefined,
			activeTool: null,
			availableTools: []
		}
	}

	componentWillMount() {
		var tools = this.getAvailableTools();
		this.setState({
			activeTool: tools[0],
			availableTools: tools
		});
	}

	getAvailableTools() {
		var tools = [];
		if (this.props.userInfo.authenticator_enable) {
			tools.push(VERIFICATION_TOOL.AUTHENTICATOR);
		}
		if (this.props.userInfo.mobile_no) {
			tools.push(VERIFICATION_TOOL.MOBILE);
		}
		if (this.props.userInfo.email && this.props.userInfo.email_v) {
			tools.push(VERIFICATION_TOOL.EMAIL);
		}
		return tools;
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.unlockVerify(this.state.code, this.state.activeTool);
	}

	handleGetCode() {
		if (this.state.activeTool === VERIFICATION_TOOL.EMAIL) {
			this.props.getCode(null, true, this.props.language.lang);
		} else {
			this.props.getCode(null, null, null, 'send_otp_unlock', null);
		}
	}

	handleChangeCode(event) {
		this.setState({code: event.target.value});
	}

	checkError() {
		var errMsg = null;
		if (this.props.verification.get_status) {
			errMsg = getSendOTPErrorMessage(this.props.verification.get_status);
		} else if (this.props.unlock.status) {
			errMsg = getUnlockErrorMessage(this.props.unlock.status);
		}
		if (errMsg) {
			return (
				<div className="content__form-errmsg-item content__form-errmsg-item--visible">
					{errMsg}
				</div>
			);
		}
	}

	renderAlternativeSMS() {
		if (VERIFICATION_TOOL.MOBILE !== this.state.activeTool && this.state.availableTools.indexOf(VERIFICATION_TOOL.MOBILE) >= 0) {
			return (
				<a href="#" className="changepwd-method__item" onClick={() => {this.setState({activeTool: VERIFICATION_TOOL.MOBILE})}}>
					<div className="changepwd-method__item-icon--mobile"></div>
					<div className="changepwd-method__item-txt">
						SMS
					</div>
				</a>
			);
		}
	}

	renderAlternativeAuthenticator() {
		if (VERIFICATION_TOOL.AUTHENTICATOR !== this.state.activeTool && this.state.availableTools.indexOf(VERIFICATION_TOOL.AUTHENTICATOR) >= 0) {
			return (
				<a href="#" className="changepwd-method__item" onClick={() => {this.setState({activeTool: VERIFICATION_TOOL.AUTHENTICATOR})}}>
					<div className="changepwd-method__item-icon--mobile"></div>
					<div className="changepwd-method__item-txt">
						Authenticator
					</div>
				</a>
			);
		}
	}

	renderAlternativeEmail() {
		if (VERIFICATION_TOOL.EMAIL !== this.state.activeTool && this.state.availableTools.indexOf(VERIFICATION_TOOL.EMAIL) >= 0) {
			return (
				<a href="#" className="changepwd-method__item" onClick={() => {this.setState({activeTool: VERIFICATION_TOOL.EMAIL})}}>
					<div className="changepwd-method__item-icon--email"></div>
					<div className="changepwd-method__item-txt">
						Email
					</div>
				</a>
			);
		}
	}

	renderAlternativeTools() {
		if (this.state.availableTools.length > 1) {
			return (
				<div className="changepwd-method">
					<div className="changepwd-method__title">{trans('alternative_verification_title')}</div>
					<div className="changepwd-method__list">
						{this.renderAlternativeSMS()}
						{this.renderAlternativeEmail()}
						{this.renderAlternativeAuthenticator()}
					</div>
				</div>
			);
		}
	}
	
	renderSendInfo() {
		switch (this.state.activeTool) {
			case VERIFICATION_TOOL.AUTHENTICATOR:
				return (
					<div className="content__sendinfo">
						{trans('authenticator_hint')}
					</div>
				);
			case VERIFICATION_TOOL.MOBILE:
				const gatewayBefore = trans(this.state.gatewayBefore|| 'sms_gateway');
				const gatewayAfter = trans(this.props.verification.gateway || 'sms_gateway');
				return (
					<div className="content__sendinfo" id="J-sendinfo">
						<div className="content__sendinfo-before">{trans('get_otp_hint', { gateway: gatewayBefore })}</div>
						<div className="content__sendinfo-after">
							{trans('sent_opt_info', { gateway: gatewayAfter })}
						</div>
					</div>
				);
			case VERIFICATION_TOOL.EMAIL:
				return (
					<div className="content__sendinfo" id="J-sendinfo">
						<div className="content__sendinfo-before">{trans('get_email_code_hint')}</div>
						<div className="content__sendinfo-after">
							{trans('sent_email_code_info')}
						</div>
					</div>
				);
		}
	}

	renderAuthenticatorContentForm() {
		return (
			<div className="content__form">
				<form method="post" action="" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>
					<div className="content__form-input">
						<input type="tel" maxLength="6" className="content__form-input-widget J-validated-field"
							placeholder={trans('verify_code_placeholder')} onChange={this.handleChangeCode.bind(this)}>
						</input>
					</div>
					<div className="content__form-errmsg" id="J-errdisplay-otp">
						{this.checkError()}
					</div>
					<div className="content__submit-wrap">
						<input type="submit" className="content__submit" value={trans('verify_btn')}></input>
					</div>
				</form>
			</div>
		);
	}

	renderSMSContentForm() {
		const full_mobile_no = getFullMobileNo(this.props.userInfo);
		return (
			<div className="content__form">
				<form method="post" action="" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>
					<div className="content__phone">
						<div className="content__phone-icon"></div>
						<div className="content__phone-num">{full_mobile_no}</div>
					</div>
					{!!this.props.userInfo.country_code && (
						<MobileOtpInputField
							template_id="send_otp_unlock"
							value={this.state.code}
							onChange={this.handleChangeCode.bind(this)}
							onChangeGateway={(gatewayBefore) => this.setState({ gatewayBefore })}
						/>
					)}
					<div className="content__form-errmsg" id="J-errdisplay-otp">
						{this.checkError()}
					</div>
					<div className="content__submit-wrap">
						<input type="submit" className="content__submit" value={trans('verify_btn')}></input>
					</div>
				</form>
			</div>
		);
	}

	renderEmailContentForm() {
		return (
			<div className="content__form">
				<form method="post" action="" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>
					<div className="content__phone">
						<div className="content__email-icon"></div>
						<div className="content__phone-num">{this.props.userInfo.email}</div>
					</div>
					<div className="content__form-otpcode">
						<div className="content__form-input">
							<input type="tel" maxLength="8" className="content__form-input-widget J-validated-field"
								placeholder={trans('verify_code_placeholder')}
								onChange={this.handleChangeCode.bind(this)}>
							</input>
						</div>
						<a href="javascript:;" className="content__form-getotp" id="J-getotp-trigger">
							<div className="content__form-getotp-before" onClick={this.handleGetCode.bind(this)}>
								{trans('get_code_btn')}
							</div>
							<div className="content__form-getotp-after">
								{trans('wait')} <span id="J-getotp-cd"></span>s
							</div>
						</a>
					</div>
					<div className="content__form-errmsg" id="J-errdisplay-otp">
						{this.checkError()}
					</div>
					<div className="content__submit-wrap">
						<input type="submit" className="content__submit" value={trans('verify_btn')}></input>
					</div>
				</form>
			</div>
		);
	}

	renderContentForm() {
		switch (this.state.activeTool) {
			case VERIFICATION_TOOL.AUTHENTICATOR:
				return this.renderAuthenticatorContentForm();
			case VERIFICATION_TOOL.MOBILE:
				return this.renderSMSContentForm();
			case VERIFICATION_TOOL.EMAIL:
				return this.renderEmailContentForm();
		}
	}

	renderMainPage() {
		if (this.state.availableTools.length > 0) {
			return (
				<div className="content-item--ipage__main">
					{this.renderSendInfo()}
					{this.renderContentForm()}
					{this.renderAlternativeTools()}
				</div>
			);
		} else {
			return (
				<div className="content-item--ipage__main">
					<div className="content__result">
						<div className="content__result-icon"></div>
						<div className="content__result-txt">
							{trans('no_security_tool_msg1')}
						</div>
					</div>
					<div className="content__submit-wrap">
						<a href="#" className="content__submit" onClick={this.handleClick.bind(this)}>{trans('bind_mobile_btn')}</a>
					</div>
					<br/>
					<div className="content__sendinfo">
						{trans('feedback_fail_hint_1_unlock')}&nbsp;
						<a href={CUSTOM_SERVICE_URL[[this.props.language.country]]}>{trans('customer_service_lower')}</a>&nbsp;
						{trans('no_security_tool_msg2')}
					</div>
				</div>
			);
		}
	}
	
	handleClick() {
		this.props.initMobile();
	}

	render() {
		return (
			<div className="main">
				<div className="content">
					<div className="content-item content-item--ipage content-item--single">
						<div className="content-item__title">
							{trans('unlock_title')}
						</div>
						<div className="content-item__main">
							{this.renderMainPage()}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		unlock: state.unlock,
		verification: state.verification,
		language: state.data.language
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, unlockActions, verificationActions, mobileActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UnlockVerify);


// WEBPACK FOOTER //
// ./app/components/unlock/UnlockVerify.js